const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const has = (v) => v != null && v !== "";

// Cari tipi → hızlı satış fiyat modu (Müşteri/Tedarikçi → Genel · Elektrikçi → Faturalı · Elektrikçi + KDV'siz → KDV'siz)
export const contactPosMode = (c) => (c && c.type === "elektrikci" ? (c.vat_exempt ? "kdvsiz" : "faturali") : "genel");
// Teklif/işlem modu KDV durumuna göre: elektrikçi + KDV'li → faturalı · elektrikçi + KDV'siz → faturasız (kdvsiz) · diğer → genel
export const quoteModeFor = (c, kdvOn) => (c && c.type === "elektrikci" ? (kdvOn ? "faturali" : "kdvsiz") : "genel");
export const POS_MODE_LABEL = { genel: "Genel Satış", faturali: "Elektrikçi Faturalı", kdvsiz: "Elektrikçi KDV'siz" };

// Ürün kartındaki manuel fiyatlardan (KDV dahil genel / faturalı, KDV hariç faturasız) moda göre KDV HARİÇ net birim fiyat.
// Backend _pos_prices ile aynı düşüş sırası: kendi manueli → Genel manueli → yok (null → iskonto uygulanır)
export const manualNetFor = (p, mode) => {
  if (!p) return null;
  const kdv = has(p.kdv_rate) ? Number(p.kdv_rate) : 20;
  const inclToNet = (v) => r2(Number(v) / (1 + kdv / 100));
  const g = has(p.price_general) ? inclToNet(p.price_general) : null;
  if (mode === "faturali") return has(p.price_elec_vat) ? inclToNet(p.price_elec_vat) : g;
  if (mode === "kdvsiz") return has(p.price_elec_novat) ? r2(Number(p.price_elec_novat)) : g;
  return g;
};
